module.exports = __webpack_public_path__ + "img/2014_L.812f0949.png";